import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ImageUIPlugin from '../ImageUIPlugin'
import ToggleLinkUIPlugin from '../ToggleLinkUIPlugin'
import YoutubeUIPlugin from '../YoutubeUIPlugin'

export default function InsertionUIPlugin() {
  return (
    <ButtonGroup>
      <ToggleLinkUIPlugin />
      <ImageUIPlugin />
      <YoutubeUIPlugin />
    </ButtonGroup>
  )
}
